import { Routes } from '@angular/router';
import { authGuard } from '@core/guards/auth.guard';
import { LandingComponent } from '@features/landing/pages/landing/landing';
import { environment } from '../environments/environment';

export const ROUTE_PATHS = {
  home: '',
  profile: 'profile',
  login: 'login',
  forgotPassword: 'forgot-password',
  setPassword: 'set-password',
  checkout: 'checkout',
  paymentReturn: 'payment/return',
  join: 'join',
  designSystem: 'design-system',
} as const;

export const ROUTES = {
  home: '/',
  profile: '/profile',
  login: '/profile/login',
  forgotPassword: '/profile/forgot-password',
  setPassword: '/profile/set-password',
  join: '/join',
  paymentReturn: '/checkout/payment/return',
} as const;

export type RouteKey = keyof typeof ROUTES;

export const routes: Routes = [
  { path: ROUTE_PATHS.home, component: LandingComponent },
  {
    path: ROUTE_PATHS.profile,
    children: [
      {
        path: '',
        data: { nav: false },
        loadComponent: () =>
          import('@features/profile/pages/profile/profile').then((m) => m.ProfileComponent),
        canActivate: [authGuard],
      },
      {
        path: ROUTE_PATHS.login,
        data: { nav: false },
        loadComponent: () =>
          import('@features/profile/pages/login/login').then((m) => m.LoginComponent),
      },
      {
        path: ROUTE_PATHS.forgotPassword,
        data: { nav: false },
        loadComponent: () =>
          import('@features/profile/pages/forgot-password/forgot-password').then(
            (m) => m.ForgotPasswordComponent,
          ),
      },
      {
        path: ROUTE_PATHS.setPassword,
        data: { nav: false },
        loadComponent: () =>
          import('@features/profile/pages/set-password/set-password').then(
            (m) => m.SetPasswordComponent,
          ),
      },
    ],
  },
  {
    path: ROUTE_PATHS.checkout,
    children: [
      {
        path: ROUTE_PATHS.paymentReturn,
        loadComponent: () =>
          import('@features/checkout/pages/payment-return/payment-return').then(
            (m) => m.PaymentReturnComponent,
          ),
      },
    ],
  },
  {
    path: ROUTE_PATHS.join,
    loadComponent: () =>
      import('@features/checkout/pages/join/join').then((m) => m.JoinComponent),
  },
  // The living styleguide, on every environment but production.
  ...(environment.envName === 'prod'
    ? []
    : [
        {
          path: ROUTE_PATHS.designSystem,
          loadComponent: () =>
            import('@design-system/styleguide/styleguide').then((m) => m.StyleguideComponent),
        },
      ]),
  { path: '**', redirectTo: ROUTE_PATHS.home },
];
